var map = {
	"./bonus_symbol_0.png": "afea",
	"./bonus_symbol_1.png": "a4be",
	"./bonus_symbol_2.png": "adbd",
	"./bonus_symbol_3.png": "d5d2",
	"./bonus_symbol_4.png": "1dca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ec3";